// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2loxO","col":"styles_col__1tToN","fulfillmentStatus":"styles_fulfillmentStatus__2Zr7M","emailCol":"styles_emailCol__12MwZ"};